import { Injectable } from '@angular/core';
import {CommonService} from './common.service';
import {ToastMessagesService} from './toast-messages.service';
import {ChildrenAffirmation, ReportAffirmation} from '../models/applicationFeature';

@Injectable({
  providedIn: 'root'
})
export class AffirmationService {

  constructor(public commonService: CommonService,
              public toastMessagesService: ToastMessagesService) { }


  /////////////////// Initialize Report Affirmations////////////////////////////////////////
  // return Report Affirmation Array
  // affirmation: Actual Affirmation
  // totalSent: Sum of affirmations Sent
  // completed: Sum of Completed Affirmations
  // notAnswered: Sum of Not answered affirmations
  ///////////////////////////////////////////////////////////
  async initReportAffirmations(studentClasses, childrenEnrollments): Promise<ReportAffirmation[]> {
    const reportAffirmations: ReportAffirmation[] = [];
    try {
      const affirmationsRequest = await this.commonService.getList(`affirmations`);
      const affirmations = affirmationsRequest.object;
      for (const affirmation of affirmations) {
        const children = childrenEnrollments.filter(enrollment => enrollment.activity_id === affirmation.activityId);
        const reportAffirmation: ReportAffirmation = {
          affirmation,
          totalSent:  !affirmation.classRestrictions || affirmation.classRestrictions === 'null' ?
              this.allClassesStudentsCount(studentClasses) :
              this.specificClassesStudentsCount(affirmation.classRestrictions, studentClasses),
          completed: children.length,
          notAnswered: 0,
        };
        reportAffirmation.notAnswered = reportAffirmation.totalSent - reportAffirmation.completed;

        if (affirmation.hasDeadline === 1) {
          if (Date.now() > new Date(affirmation.deadline_date).getTime()) {
            affirmation.is_published = -1;
          }
        }


        reportAffirmations.push(reportAffirmation);
      }

      return reportAffirmations;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initChildrenAffirmations(): Promise<ChildrenAffirmation[]> {
    try {
      const enrollmentsRequest = await this.commonService.getList(`affirmations/children/activity`);
      const enrollments = enrollmentsRequest.object as ChildrenAffirmation[];
      for (const enrollment of enrollments) {
        enrollment.childDisplayName = `${enrollment.child_first_name} ${enrollment.child_last_name}`;
      }
      return enrollments;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  allClassesStudentsCount(studentClasses): number {
    let count = 0;
    for (const studentClass of studentClasses) {
      count += studentClass.classLength;
    }
    return count;
  }

  specificClassesStudentsCount(classRestrictions: string, studentClasses): number {
    let count = 0;
    const restrictions = JSON.parse(classRestrictions);
    for (const studentClass of studentClasses) {
      for (const restriction of restrictions) {
        if (restriction.id === studentClass.class.id) {
          count += studentClass.classLength;
        }
      }
    }
    return count;
  }
}

